<template>
  <div>
    <v-select
      :value="role"
      :items="filterRoles"
      :label="$i18n.t(label)"
      @change="changedTo"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div ripple dense class="height32">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <div ripple dense style="width: 100%">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-select>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { doGet } from "@/store/common/module/apis";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "UserRoleSelect",
  props: {
    value: {
      default: null,
    },
    corp: {
      default: false,
    },
    label: {
      default: "User Role",
    },
    rules: {
      default: () => [],
    },
    clearable: {
      default: false,
    },
  },
})
export default class UserRoleSelect extends (Vue, Themeable) {
  role = null;
  roles = [];
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.role = null;
    this.$emit("input", null);
  }

  get filterRoles() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.roles;
    const fs = this.roles.filter(function (s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) this.role = newVal;
    if (newVal && newVal._id) this.$emit("input", newVal._id);
    if (!newVal) this.$emit("input", null);
  }

  selectValue() {
    if (this.value) {
      for (let i = 0; i < this.roles.length; i++) {
        if (this.roles[i]._id === this.value) {
          this.role = this.roles[i];
          this.$emit("input", this.role._id);
          return;
        }
      }
    }
  }

  async init() {
    // if (val != null && val !== "") {
    this.filter = "";
    this.loading = true;
    this.roles = await doGet("/api/role/list");
    this.loading = false;
    this.selectValue();
    // } else {
    //   this.roles = [];
    //   this.loading = false;
    //   this.selectValue();
    // }
  }

  async mounted() {
    await this.init();
    this.loading = false;
  }

  @Watch("corp", { immediate: true })
  async onCorpChange() {
    await this.init();
  }

  @Watch("value")
  onValueChange() {
    this.selectValue();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
</style>
